
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_foics_34",
  "outline": "awsui_outline_4yi2u_foics_67",
  "toggle-control": "awsui_toggle-control_4yi2u_foics_89",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_foics_107",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_foics_110",
  "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_foics_116",
  "toggle-handle": "awsui_toggle-handle_4yi2u_foics_125",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_foics_150",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_foics_157",
  "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_foics_161",
  "awsui-toggle-tail-off": "awsui_awsui-toggle-tail-off_4yi2u_foics_1",
  "awsui-toggle-tail-on": "awsui_awsui-toggle-tail-on_4yi2u_foics_1"
};
  